export * from './individual-search-table.module';
export * from './individual-search-table.component';
